import { cn } from "@/lib/utils";
import React from "react";

function InputText({
  className,
  children,
  ...otherProps
}: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">) {
  return (
    <input
      type="text"
      className={cn(
        "py-1.5 px-3 rounded-lg border border-gray-100 mt-2 w-full h-[39px] focus:outline-secondary disabled:text-slate-500 text-black",
        className
      )}
      {...otherProps}
    >
      {children}
    </input>
  );
}

export default InputText;
